import { createContext, useContext, useState, useEffect } from "react";
import Url, { TQueryParams } from "../Url";
import Path, {TQueryParamsNull} from "./Path";

export interface IPathContext {
    path:string;
    hash:string;
    query:TQueryParams;
    setPath:(url:string)=>void;
    setHash:(hash:string)=>void
    setQuery:(query:TQueryParamsNull)=>void;
}
const PathContext = createContext<IPathContext>({path:"",hash:"",query:{},setPath:()=>{},setQuery:()=>{},setHash:()=>{}})
const g_path = new Path().parse(document.location.href)

export const usePath = () => useContext(PathContext)

export default function PathProvider(props:{children:any}){
    const [path,_setPath] = useState<string>(g_path.path);
    const [query,_setQuery] = useState<TQueryParams>(g_path.query);
    const [hash,_setHash] = useState<string>(g_path.hash)

    useEffect(() => {
        const _update = (url:Path) => {
          if (url.path!=path) _setPath(url.path)
          if (JSON.stringify(query)!=JSON.stringify(url.query)) _setQuery({...url.query})
          if (url.hash!=hash) _setHash(url.hash)
        }
        g_path.addListener("change", _update)
        return () => {g_path.removeListener("change", _update)}
      },[])
    const setPath = (url:string|Url) => g_path.set(url)
    const setQuery = (query:TQueryParamsNull) => { g_path.setParams(query); _setQuery({...g_path.query}) }
    const setHash = (hash:string) => g_path.setHash(hash)

    return <PathContext.Provider value={{path,query,hash,setPath,setQuery,setHash}}>
        {props.children}
    </PathContext.Provider>
}